import { render } from "./index.vue?vue&type=template&id=72b1c87a&scoped=true"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"

import "./index.vue?vue&type=style&index=0&id=72b1c87a&lang=css"
import "./index.vue?vue&type=style&index=1&id=72b1c87a&scoped=true&lang=scss"

import exportComponent from "/root/workspace/Collection_EVMd/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-72b1c87a"]])

export default __exports__